import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useFormikContext } from "formik";
import { getRegions } from "@qgiv/core-js";
import {
    FormikCheckbox,
    FormikField,
    FormikSelect,
    CountryOptions,
    RegionOptions,
} from "@qgiv/core-donor";
import ConnectedMailingAddressPreview from "./ConnectedMailingAddressPreview";

const BillingFields = ({
    billingAddressLabel,
    billingAddressLabel2,
    billingCityLabel,
    billingStateLabel,
    billingZipLabel,
    billingCountryLabel,
}) => {
    const {
        values: { Billing_Country },
    } = useFormikContext();
    const [regions, setRegions] = useState([]);
    useEffect(() => {
        if (Billing_Country) {
            getRegions(Billing_Country).then((res) => {
                setRegions(res.data);
            });
        }
    }, [Billing_Country]);
    const stateZipRequired = Billing_Country === "US" ? "true" : "false";
    return (
        <div className="grid">
            <div className="col col--12">
                <FormikField
                    id="Billing-Address"
                    name="Billing_Address"
                    label={billingAddressLabel}
                    type="text"
                    ariaRequired="true"
                />
            </div>

            <div className="col col--12">
                <FormikField
                    id="Billing_Address_2"
                    name="Billing_Address_2"
                    label={billingAddressLabel2}
                    type="text"
                    descText="Optional"
                />
            </div>
            <div className="col col--12 col--md-4">
                <FormikField
                    id="Billing-City"
                    name="Billing_City"
                    label={billingCityLabel}
                    type="text"
                    ariaRequired="true"
                />
            </div>
            <div className="col col--12 col--md-4">
                <FormikSelect
                    id="Billing-State"
                    name="Billing_State"
                    label={billingStateLabel}
                    type="select"
                    ariaRequired={stateZipRequired}
                >
                    <RegionOptions regions={regions} />
                </FormikSelect>
            </div>
            <div className="col col--12 col--md-4">
                <FormikField
                    id="Billing-Zip"
                    name="Billing_Zip"
                    label={billingZipLabel}
                    type={Billing_Country === "US" ? "zip" : "text"}
                    ariaRequired={stateZipRequired}
                />
            </div>
            <div className="col col--12">
                <FormikSelect
                    id="Billing-Country"
                    name="Billing_Country"
                    label={billingCountryLabel}
                    type="select"
                    ariaRequired="true"
                >
                    <CountryOptions />
                </FormikSelect>
            </div>
        </div>
    );
};

BillingFields.propTypes = {
    billingAddressLabel: PropTypes.string.isRequired,
    billingAddressLabel2: PropTypes.string.isRequired,
    billingCityLabel: PropTypes.string.isRequired,
    billingStateLabel: PropTypes.string.isRequired,
    billingZipLabel: PropTypes.string.isRequired,
    billingCountryLabel: PropTypes.string.isRequired,
};

const BillingAddress = ({
    displayBillingAddress,
    subsectionHeading = "Billing Address",
    additionalText = "",
    sameAsMailingLabel = "Same as Mailing Address",
    billingAddressLabel = "Billing Address",
    billingAddressLabel2 = "Apartment, Suite, Etc.",
    billingCityLabel = "Billing City",
    billingStateLabel = "Billing State",
    billingZipLabel = "Billing Zip Code",
    billingCountryLabel = "Billing Country",
}) => {
    const { values } = useFormikContext();
    const { Billing_Address_Use_Mailing = true } = values;
    return (
        displayBillingAddress && (
            <div className="grid">
                <div className="col col--12">
                    <h4>{subsectionHeading}</h4>
                    {additionalText && <p>{additionalText}</p>}
                    <FormikCheckbox
                        id="Billing-Address-Use-Mailing"
                        name="Billing_Address_Use_Mailing"
                    >
                        {sameAsMailingLabel}
                    </FormikCheckbox>
                    <div className="grid">
                        {Billing_Address_Use_Mailing ? (
                            <div className="col col--12 col--md-6 col--no-top-gutter">
                                <ConnectedMailingAddressPreview />
                            </div>
                        ) : (
                            <div className="col col--12 col--no-top-gutter">
                                <BillingFields
                                    billingAddressLabel={billingAddressLabel}
                                    billingAddressLabel2={billingAddressLabel2}
                                    billingCityLabel={billingCityLabel}
                                    billingStateLabel={billingStateLabel}
                                    billingZipLabel={billingZipLabel}
                                    billingCountryLabel={billingCountryLabel}
                                />
                            </div>
                        )}
                    </div>
                </div>
            </div>
        )
    );
};

BillingAddress.propTypes = {
    displayBillingAddress: PropTypes.bool.isRequired,
    sameAsMailingLabel: PropTypes.string,
    subsectionHeading: PropTypes.string,
    additionalText: PropTypes.string,
    billingAddressLabel: PropTypes.string,
    billingAddressLabel2: PropTypes.string,
    billingCityLabel: PropTypes.string,
    billingStateLabel: PropTypes.string,
    billingZipLabel: PropTypes.string,
    billingCountryLabel: PropTypes.string,
};

export default BillingAddress;
